import appConfig from '../config';
import { getGlobalCookie } from '../utils';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';

/**
 * Fetches user permissions from the SPARTA console API and
 * dispatches GET_PERMISSIONS with the response payload.
 */
export function getPermissionsAc(params = {}, body = {}) {
  return async (dispatch) => {
    try {
      const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
      if (!lessorAccess) return;

      const response = await fetch(
        `${appConfig.api.commonApi}/user/permission/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getGlobalCookie('access')}`,
          },
          body: JSON.stringify({
            lessor_id: lessorAccess.id,
            ...body,
          }),
        }
      );

      if (!response.ok) return;

      const data = await response.json();
      dispatch({ type: GET_PERMISSIONS, payload: { ...data, lessor: lessorAccess } });
    } catch (_) {
      // silently fail — PrivateRoute will redirect on next check
    }
  };
}
